import { masterListAPI, softwarelistAPI } from "api";


const generateSelect = (list) => {
  return list?.map((Val, id) => {
    const labelcount = (
      <>
        <span className="text-default">{Val.name}</span>
        &nbsp;
        <span className="text-primary">({Val.count})</span>
      </>
    );
    return { label: labelcount, value: Val.name };
  });
};
class logClient {
  async filterList() {
    try {
      const [master, software] = await Promise.all([
        masterListAPI({}),
        softwarelistAPI({})
      ]);

      return { master: generateSelect(master.data.data || []), software: generateSelect(software.data.data || []) }
    } catch (error) {
      console.log(error)
      return { error }
    }
  }

}


const logClientInstance = new logClient();

export default logClientInstance;